"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicWidgetsService = void 0;
const widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/widgets/widgets");
const to_error_1 = require("../../parsers/to-error");
const env_1 = require("@wix/wix-vod-constants/env");
const common_1 = require("@wix/wix-vod-shared/common");
class PublicWidgetsService {
    constructor(httpClient, baseUrl) {
        this.getWidgetSettings = (widgetId) => this.publicWidgets
            .getSettings(widgetId)
            .then((response) => (0, common_1.keysToCamelCase)(response.data))
            .catch(to_error_1.toError);
        this.getWidgetSettingsByInstanceId = (instanceId) => this.publicWidgets
            .getSettingsByInstanceId(instanceId)
            .then((response) => (0, common_1.keysToCamelCase)(response.data))
            .catch(to_error_1.toError);
        this.buildVideoCardsDeeplinkUrl = ({ channelId, videoId, fallbackUrl, instance, }) => this.publicWidgets.buildVideoCardsDeeplinkUrl({
            host: env_1.PRODUCTION_HOSTS.catalog,
            channelId,
            videoId,
            fallbackUrl,
            instance,
        });
        this.buildChannelCardsDeeplinkUrl = ({ channelId, fallbackUrl, instance, }) => this.publicWidgets.buildChannelCardsDeeplinkUrl({
            host: env_1.PRODUCTION_HOSTS.catalog,
            channelId,
            fallbackUrl,
            instance,
        });
        this.publicWidgets = new widgets_1.PublicWidgets(httpClient, baseUrl);
    }
}
exports.PublicWidgetsService = PublicWidgetsService;
//# sourceMappingURL=widgets.js.map